/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

function getRedirectUri() {
	// Check the environment to determine the redirect URL
	if (process.env.NODE_ENV === "development") {
		return "http://localhost:3000/";
	} else if (process.env.NODE_ENV === "production") {
		return "https://platform.soroco.com/";
	} else {
		throw new Error("Invalid environment");
	}
}

export const msalConfig = {
	auth: {
		clientId: "a6709d31-2dc1-4eb2-b050-efb5a183ca42",
		authority:
			"https://login.microsoftonline.com/217024cc-23bf-42d2-a7cf-d270166db3e2",
		redirectUri: getRedirectUri(),
	},
	cache: {
		cacheLocation: "sessionStorage", // This configures where your cache will be stored
		storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
	},
	system: {
		loggerOptions: {
			loggerCallback: (level, message, containsPii) => {
				if (
					process.env.NODE_ENV === "production" ||
					process.env.NODE_ENV === "development"
				) {
					// Stop logging in production and development
					return;
				}
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						console.info(message);
						return;
					case LogLevel.Verbose:
						console.debug(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
					default:
						return;
				}
			},
		},
	},
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
	scopes: ["User.Read"],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
	graphMeEndpoint: "Enter_the_Graph_Endpoint_Herev1.0/me", //e.g. https://graph.microsoft.com/v1.0/me
};
